import React, { Fragment, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import TopMenu from "./TopMenu";
import Path from "components/common/path";
import { useDispatch, useSelector } from "react-redux";
import TemplateModal from './TemplateModal'
import Dropdown from "components/common/dropdowncomponents/dropdown";
import DropdownItem from "components/common/dropdowncomponents/dropdownitem";
import LivefeedModal from './LivefeedModal'

const TopMenuContainer = props => {
  // passedProps
  const { router, editorMode, editorKey } = props;

  const [savingType, setSavingType] = useState(''); // mode to save
  const [nullLocationSlides, setNullLocationSlides] = useState([{}]);
  const [slideShowDontHaveMapAPI, setSlideShowDontHaveMapAPI] = useState([{}])
  const livefeedModal = useRef(null);
  const templateModal = useRef(null);

  const dispatch = useDispatch();
  const nodeMap = useSelector(state => state.overviewReducer.nodeMap)
  const { livefeedSlides, livefeedName } = useSelector(state => state.livefeededitor);
  const user = useSelector(state => state.myAccountReducer.user);
  const [creatorEmail, setCreatorEmail] = useState('');

  useEffect(
    () => {
      setCreatorEmail(user.email);
    },
    [user.email]
  );

  // livefeed conditon save
  function livefeedConditionsCheck() {
    let nullLocationArrObj = [];
    let slideShowArrObj = [];

    livefeedSlides.slice().map((slide, index) => {
      if (slide.slideType !== "locationsList") {
        // check if chosen LocationsID is in treeMap, handle case if the id of node in tree map has changed
        let refinedLocationsID = slide.floorplanOptions.locationsID.filter(id => nodeMap[id])

        if (!refinedLocationsID.length > 0) {
          nullLocationArrObj.push({ id: index, slideType: slide.slideType });
        }
        if (slide.slideType === "slideshow" && slide.floorplanOptions.mapApiKey === "") {
          slideShowArrObj.push({ id: index, slideType: slide.slideType })
        }
      }
    });
    setNullLocationSlides(nullLocationArrObj)
    setSlideShowDontHaveMapAPI(slideShowArrObj)
  }


  //-------------------------------------------function handle Save -----------------------------------
  function handleSave(mode) {
    // check condition before submit editTemplate or editLivefeed
    switch (mode) {
      case "template":
        {
          setSavingType("template");
          templateModal.current.open();
        }
        break;
      case "livefeed":
        {
          setSavingType("livefeed");
          livefeedConditionsCheck();
          livefeedModal.current.open();
        }
        break;
      case "update":
        {
          setSavingType("update");
          livefeedConditionsCheck();
          editorMode === "editTemplate" ? templateModal.current.open() : livefeedModal.current.open();
        }
        break;
    }
  }

  const breadcrumbs = [
    {
      path: "/livefeed",
      name: "Livefeed"
    },
    {
      shouldReload: true,
      path: "/livefeed/editor",
      name: pageTitle(editorMode, true)
    }
  ];

  const dropdownSave = (
    <Dropdown
      className="dropdown-save"
      noArrow={true}
      header={
        <div className={`justify-center dropdown-header-text`}>
          <span className="cursor--pointer">
            <i className="material-icons material-icons_size save--icons">save</i>
            Save
            <i style={{ marginLeft: 5, marginBottom: 4, fontSize: "24px" }} className="material-icons">
              keyboard_arrow_down
            </i>
          </span>
        </div>
      }
      toggleable={true}
    >
      <Fragment>
        {(editorMode === "editTemplate" || editorMode === "editLivefeed") && (
          <DropdownItem>
            <div onClick={() => handleSave("update")}>Update</div>
          </DropdownItem>
        )}
        <DropdownItem>
          <div onClick={() => handleSave("livefeed")}>Save as Livefeed...</div>
        </DropdownItem>
        <DropdownItem>
          <div onClick={() => handleSave("template")}>Save as Template...</div>
        </DropdownItem>
      </Fragment>
    </Dropdown>
  );

  function pageTitle(editorMode, isBc) {
    switch (editorMode) {
      case "editTemplate":
        return `${isBc ? `Edit ${livefeedName} [Template]` : "Edit Template"}`;
      case "editLivefeed":
        return `${isBc ? `Edit ${livefeedName} [Livefeed]` : "Edit Livefeed"}`;
      case "createLivefeed":
        return "Create Livefeed";
      case "createTemplate":
        return "Create Template";
    }
  }

  let isCreateMode = editorMode === "createTemplate" || editorMode === "createLivefeed";
  // if user edits existing livefeed or template, then choose to save as new
  if ((savingType === "template") | (savingType === "livefeed")) {
    isCreateMode = true;
  }
  return (
    <TopMenu
      pageTitle={pageTitle(editorMode, false)}
      saveBtnText={"Save changes"}
      onClickCancel={() =>
        router.push({
          pathname: "/livefeed"
        })
      }
      cancelBtnText={"Cancel"}
      onSaveDropdown={dropdownSave}
    >
      <Fragment>
        <Path regularBc={true} path={breadcrumbs} />
        {/*--------------------------------------Livefeed modal------------------------------------------- */}
        <LivefeedModal
          livefeedName={livefeedName}
          nullLocationSlides={nullLocationSlides}
          slideShowDontHaveMapAPI={slideShowDontHaveMapAPI}
          livefeedSlides={livefeedSlides}
          nodeMap={nodeMap}
          creatorEmail={creatorEmail}
          editorMode={editorMode}
          savingType={savingType}
          dispatch={dispatch}
          router={router}
          editorKey={editorKey}
          isCreateMode={isCreateMode}
          ref={livefeedModal}
        />
        <TemplateModal
          dispatch={dispatch}
          isCreateMode={isCreateMode}
          savingType={savingType}
          creatorEmail={creatorEmail}
          router={router}
          editorMode={editorMode}
          editorKey={editorKey}
          ref={templateModal}
          livefeedSlides={livefeedSlides}
          livefeedName={livefeedName}
        />
      </Fragment>
    </TopMenu>
  );
};

TopMenuContainer.propTypes = {
  router: PropTypes.object.isRequired,
  editorMode: PropTypes.string
};

export default TopMenuContainer;



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/TopMenuContainer/index.jsx